/* @flow */

import React from 'react';
import { Table, Label, Icon } from 'semantic-ui-react';
import ConfirmDeleteButton from 'shared/components/ConfirmDeleteButton';
import type { MySpaceEvent } from '../types';

type Props = {
  event: MySpaceEvent,
  onDelete: (event: MySpaceEvent) => void,
};

const styles = {
  row: {
    cursor: 'pointer',
  },
};

const EventItem = ({ event, onDelete }: Props) => {
  const onClick = () => {
    window.location.assign(`/mc/calendar/events/${event.id}`);
  };

  const deleteEvent = evt => {
    evt.stopPropagation();
    evt.preventDefault();

    onDelete(event);
  };

  return (
    <Table.Row onClick={onClick} style={styles.row}>
      <Table.Cell collapsing>
        <ConfirmDeleteButton
          className="red tiny icon"
          content={<Icon name="close" />}
          modalTitle="Suppression"
          modalContent="Êtes-vous sûr(e) de vouloir supprimer cet évènement ?"
          onConfirm={deleteEvent}
        />
      </Table.Cell>
      <Table.Cell>{event.title}</Table.Cell>
      <Table.Cell textAlign="center">
        <Label color="green" horizontal>
          {event.thematic}
        </Label>
      </Table.Cell>
      <Table.Cell textAlign="center">
        {event.isPublished ? (
          <Label color="green" horizontal>
            Publié
          </Label>
        ) : (
          <Label horizontal>Brouillon</Label>
        )}
      </Table.Cell>
      <Table.Cell textAlign="center">{event.date}</Table.Cell>
    </Table.Row>
  );
};

export default EventItem;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/EventItem.js